import React, { FC } from 'react';
import { Paper, Tabs, Tab } from '@material-ui/core';
import LocalParking from '@material-ui/icons/LocalParking';
import Computer from '@material-ui/icons/Computer';
import AllInbox from '@material-ui/icons/AllInbox';
import Search from '@material-ui/icons/Search';
import Build from '@material-ui/icons/Build';
import { makeStyles } from '@material-ui/core/styles';

interface Props {
  currentPage: number;
  handleChange: (event: React.ChangeEvent<{}>, newValue: number) => void;
  currentNav: {
    location: boolean;
    device: boolean;
    search: boolean;
    log: boolean;
    manage: boolean;
  };
}

const useStyles = makeStyles({
  root: {
    flexGrow: 1,
  },
});

const NavigationTabs: FC<Props> = ({ currentPage, handleChange, currentNav }) => {
  const classes = useStyles();

  return (
    <Paper square className={classes.root}>
      <Tabs
        value={currentPage}
        onChange={handleChange}
        variant="fullWidth"
        indicatorColor="primary"
        textColor="primary"
        aria-label="icon label tabs example"
      >
        <Tab disabled={!currentNav.location} icon={<LocalParking />} label="Pladsoversigt" />
        <Tab disabled={!currentNav.device} icon={<Computer />} label="Automatoversigt" />
        <Tab disabled={!currentNav.search} icon={<Search />} label="Søg" />
        <Tab disabled={!currentNav.log} icon={<AllInbox />} label="Hændelseslog" />
        <Tab disabled={!currentNav.manage} icon={<Build />} label="Administrer" />
      </Tabs>
    </Paper>
  );
};

export default NavigationTabs;